import React from 'react'

const Footerbottom = () => {
  return (
    <div className='w-full py-20'>
        <p className='text-center text-gray-500 text-base'>
        © 2024. All Rights reserved by Muhammad Awais.
        </p>
    </div>
  )
}

export default Footerbottom